import { useMutation } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';

/**
 * Tear down an Activity call: transitions all non-terminal Call rows for the
 * issue (RINGING->CANCELLED, ACTIVE->ENDED). Called by the caller on hang up;
 * still-ringing admins' useCallUpdates subscriptions see the transition.
 */
export const useEndActivityCall = () => {
  const fetcherFn = useFetcher<
    { call: { endActivityCall: { call: { id: string; state: string } } } },
    { input: { issueId: string } }
  >(END_ACTIVITY_CALL);

  return useMutation({
    mutationFn: async (issueId: string): Promise<{ id: string; state: string }> => {
      const data = await fetcherFn({ input: { issueId } });
      return data.call.endActivityCall.call;
    },
  });
};

const END_ACTIVITY_CALL = `
  mutation END_ACTIVITY_CALL($input: EndActivityCallInput!) {
    call {
      endActivityCall(input: $input) {
        call {
          id
          state
        }
      }
    }
  }
`;
